import { GetterTree } from "vuex";
import { InvoiceSentConfirmationInformationAdminzoneState, RootState } from "@/types/store/adminzone";
import { InvoiceSentConfirmationData } from "@/types";

export const getters: GetterTree<InvoiceSentConfirmationInformationAdminzoneState, RootState> = {
  GET_INVOICE_SENT_CONFIRMATION: (state): Array<InvoiceSentConfirmationData> => state.invoiceConfirmationInformation
}
